import React, { useState, useEffect } from 'react';

const ClickEffect = () => {
    const [coords, setCoords] = useState({ x: 0, y: 0 });
    const [ripple, setRipple] = useState(false);

    const handlePointerDown = (e) => {
        setCoords({ x: e.clientX, y: e.clientY });
        setRipple(false);
        setTimeout(() => setRipple(true), 10);
    };

    useEffect(() => {
        window.addEventListener('pointerdown', handlePointerDown);
        return () => window.removeEventListener('pointerdown', handlePointerDown);
    }, []);

    return (
        <>
            {ripple && (
                <div
                    className="pointer-events-none fixed border-2 border-blue-400 rounded-full animate-ripple z-[9999]"
                    style={{
                        left: coords.x,
                        top: coords.y,
                        transform: 'translate(-50%, -50%)',
                        width: '20px',
                        height: '20px',
                    }}
                />
            )}
        </>
    );
};

export default ClickEffect;
